import LineScale from './line-scale.vue'

export default {
  LineScale,
}